type QueryKeyParams = {
  operationName: string;
  params?: Record<string, unknown>;
} & Record<string, unknown>;

export const queryKeyMutator = ({ operationName, params, ...rest }: QueryKeyParams, _queryOptions: unknown) => {
  return [operationName, ...(params ? Object.values(params) : []), ...Object.values(rest)];
};
